import { useState } from "react";
import "./App.css";
import tapinLogo from "./Assets/tapin.svg";
import { Helmet } from "react-helmet";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

// No whitespace, one @, a dot in the domain. Also no "/" anywhere: the email
// becomes a Firestore document ID, and a slash in a doc ID is a path separator.
const EMAIL_RE = /^[^@\s/]+@[^@\s/]+\.[^@\s/]+$/;

function App() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | saving | done | invalid | error

  const join = async (e) => {
    e.preventDefault();
    const cleaned = email.trim().toLowerCase();
    // 254 mirrors the Firestore rule; the input's maxLength keeps honest
    // users from ever seeing this trip.
    if (cleaned.length > 254 || !EMAIL_RE.test(cleaned)) {
      setStatus("invalid");
      return;
    }
    setStatus("saving");
    try {
      await setDoc(doc(db, "waitlist", cleaned), {
        email: cleaned,
        createdAt: serverTimestamp(),
      });
      setStatus("done");
    } catch (err) {
      // The rules only allow creates, so signing up twice comes back as
      // permission-denied. That person is already on the list; say so.
      if (err && err.code === "permission-denied") {
        setStatus("done");
      } else {
        setStatus("error");
      }
    }
  };

  return (
    <div className="App">
      <Helmet>
        <title>tap in</title>
      </Helmet>
      <header className="App-header">
        <img src={tapinLogo} className="App-logo" alt="logo" />
        {status === "done" ? (
          <p className="Waitlist-done">you're on the list</p>
        ) : (
          <form className="Waitlist" onSubmit={join}>
            <input
              className="Waitlist-input"
              type="email"
              placeholder="email"
              maxLength={254}
              autoComplete="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === "invalid" || status === "error") {
                  setStatus("idle");
                }
              }}
              aria-label="email"
            />
            <button
              className="Waitlist-button"
              type="submit"
              disabled={status === "saving"}
            >
              {status === "saving" ? "joining..." : "join waitlist"}
            </button>
          </form>
        )}
        {status === "invalid" && (
          <p className="Waitlist-note">that email doesn't look right</p>
        )}
        {status === "error" && (
          <p className="Waitlist-note">something broke, try again</p>
        )}
      </header>
    </div>
  );
}

export default App;
